/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactscomingsoon2Inputs */

const en_artifactscomingsoon2 = /** @type {(inputs: Artifactscomingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming soon`)
};

const pt_artifactscomingsoon2 = /** @type {(inputs: Artifactscomingsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em breve`)
};

/**
* | output |
* | --- |
* | "Coming soon" |
*
* @param {Artifactscomingsoon2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactscomingsoon2 = /** @type {((inputs?: Artifactscomingsoon2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactscomingsoon2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactscomingsoon2(inputs)
	return pt_artifactscomingsoon2(inputs)
});
export { artifactscomingsoon2 as "artifactsComingSoon" }